import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAvatar,{attrs:{"size":_vm.avatarSize,"color":"grey lighten-4"}},[(_vm.user.avatarurl)?_c('img',{staticStyle:{"position":"absolute"},attrs:{"src":_vm.user.avatarurl}}):_c('img',{staticStyle:{"position":"absolute"},attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }